// ============================================
// Premier Case Tracker — Frontend Types
// ============================================

export type UserRole = 'architect' | 'operations_manager' | 'team_leader' | 'queue_manager' | 'sme' | 'premier_engineer';

export const ROLE_LABELS: Record<UserRole, string> = {
  architect: 'Architect',
  operations_manager: 'Operations Manager',
  team_leader: 'Team Leader',
  queue_manager: 'Queue Manager',
  sme: 'SME',
  premier_engineer: 'Premier Engineer',
};

export const ROLE_REDIRECTS: Record<UserRole, string> = {
  architect: '/architect-dashboard',
  operations_manager: '/operations-manager-dashboard',
  team_leader: '/team-leader-dashboard',
  queue_manager: '/queue-manager-dashboard',
  sme: '/sme-dashboard',
  premier_engineer: '/premier-engineer-dashboard',
};

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  avatarUrl?: string;
  role: UserRole;
  teamId?: string;
  teamName?: string;
  teamManagerFor?: string;
  smeForTeam?: string;
  isActive: boolean;
  createdAt: string;
}

export interface Team {
  id: string;
  name: string;
  description?: string;
  managerId?: string;
  managerName?: string;
  memberCount?: number;
  isActive: boolean;
  createdAt: string;
}

export interface CaseControlAction {
  id: string;
  caseNumber: string;
  actionType: string;
  closureType?: string;
  assignedBy?: string;
  caseType?: string[];
  targetLOB?: string;
  sapReference?: string;
  isBacklogLoaded: boolean;
  createdAt: string;
}

export interface ActiveCase {
  caseNumber: string;
  assignedBy: string;
  caseType: string[];
  receivedAt: string;
  status: string;
  actionId: string;
}

export interface CSATStats {
  totalResponses: number;
  topBoxCount: number;
  topBoxPercentage: number;
  averageRating: number;
  csatPercentage: number;
  ratingBreakdown: Record<number, number>;
}

export interface IPDMetrics {
  startingBacklog: number;
  totalAssigned: number;
  netAssigned: number;
  totalClosed: number;
  totalTransferred: number;
  sameMonthTransfers: number;
  currentBacklog: number;
  target1: { goal: number; met: boolean; remaining: number };
  target2: { goal: number; met: boolean; remaining: number };
}

export interface Notification {
  id: string;
  type: string;
  title: string;
  message?: string;
  isRead: boolean;
  createdAt: string;
}

export interface TeamManagerScores {
  managerId: string | null;
  managerName: string | null;
  ipd: { startingBacklog: number; casesAssigned: number; casesClosed: number } | null;
  csat: { n5: number; n4: number; n3: number; n2: number; n1: number; totalResponses: number; csatPercentage: number } | null;
  lastUpdated: string | null;
}
